import {
    USER_WORKSPACE_ROLE_ACTIONS,
    WorkspaceAction,
} from "@common/userWorkspaceRoles";
import { useActiveWorkspaceRole } from "./useActiveWorkspaceRole";

/**
 * Returns whether the current user's workspace role allows the given action.
 * Actions and their allowed roles are defined in USER_WORKSPACE_ROLE_ACTIONS.
 */
export function useCanPerformWorkspaceAction(action: WorkspaceAction): boolean {
    const role = useActiveWorkspaceRole();

    if (!role) {
        return false;
    }

    return USER_WORKSPACE_ROLE_ACTIONS[role].includes(action);
}
